module.exports = {

    //Assorted
    Clickable: require("./assorted/Clickable"),
    SelectBox: require("./assorted/SelectBox"),
    Tab: require("./assorted/Tab"),

    //Buttons
    Button: require("./buttons/Button"),
    Buttons: require("./buttons"),
}